import { memo } from 'react';

import { ArrowDown } from '@air/next-icons';
import { Button } from '@air/primitive-button';
import { ButtonGroup } from '@air/primitive-button-group';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { SORT_BUTTON } from '~/constants/testIDs';

// Displays a hard-coded, view-only version of ViewSortingMenu that displays:
// - Sort field: "Relevance"
// - Sort direction: Descending (desc)
// - No interactivity - buttons are disabled

export const ViewSortingRelevance = memo(() => (
  <ButtonGroup>
    <Button appearance="ghost" color="grey" data-testid={`${SORT_BUTTON}-MENU`} size="small" disabled>
      Relevance
    </Button>
    <Tooltip label="Sort ascending/descending">
      <IconButton
        appearance="ghost"
        color="grey"
        data-testid={`${SORT_BUTTON}-DIRECTION`}
        data-sort="relevance"
        label="Sort ascending/descending"
        size="small"
        disabled
      >
        <ArrowDown className="size-3 rotate-0" />
      </IconButton>
    </Tooltip>
  </ButtonGroup>
));

ViewSortingRelevance.displayName = 'ViewSortingRelevance';
